module.exports = __webpack_public_path__ + "09ad34993dd69009cf2a147fa927a1ce.png";